import { useEffect, useState } from 'react';
import { useQueryHelper } from '@anytag/shared-hooks';
import { FormAction } from '@anytag/shared-types';
import { manageLocalStorage } from '@anytag/router';
import { AnalyticsFormValues } from '../schemaTypes';
import { defaultAnalyticsFormValues, getAnalyticsAccountFormState } from '../utils';

interface Props {
  defaultValues?: FormAction<AnalyticsFormValues>['defaultValues'];
}

export const useInitAnalyticsFormValues = ({ defaultValues }: Props) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const [values, setValues] = useState<AnalyticsFormValues | undefined>(undefined);

  useEffect(() => {
    initAnalyticsFromValues();
  }, []);

  useEffect(() => {
    if (values) {
      manageLocalStorage('remove', 'analyticsAccountFormState_json');
    }
  }, [values]);

  const initAnalyticsFromValues = () => {
    // we are using localstorage to save a form state when redirecting from analytics connect pages
    const stringifiedData = manageLocalStorage('get', 'analyticsAccountFormState_json');

    if (stringifiedData) {
      const { formState } = getAnalyticsAccountFormState('parse', { stringifiedData }, () => {
        enqueueSnackbar(t(`Sorry we can't access your previously saved form values, please fill them again`), {
          variant: 'error'
        });
      });

      setValues({ ...defaultValues, ...formState });
    } else {
      setValues({ ...defaultAnalyticsFormValues, ...defaultValues });
    }
  };

  return { values };
};
